<template>
  <div class="mobile-verification-container">
    <p v-if="vehicleString" class="font-weight-bold text-dark" data-test="vehicleName">{{ vehicleString }}</p>
    <h1 class="mt-4 mb-4" data-test="welcomeBackHeader">
      {{
        $t('message.credit.returnToFinanceApp.mobileVerification.welcomeBack', { name: consumerBasicInfo.firstName })
      }}
    </h1>
    <p
      class="col-sm-11 pl-0 mb-5 pb-5"
      data-test="sendVerificationCodeMsg"
      v-html-safe="
        $t('message.credit.returnToFinanceApp.mobileVerification.sendVerificationCodeMsg', {
          phoneNumber: formattedPhoneNumber,
          business: getBusinessName,
        })
      "
    ></p>
    <mobialis-form-with-validation
      @onValidate="sendMobileOtp"
      v-av-analytics-form-submit="{ elementText: $t('message.common.sendVerificationCode') }"
    >
      <mobialis-button type="submit" class="send-button" data-cy="sendCode">{{
        $t('message.common.sendVerificationCode')
      }}</mobialis-button>
    </mobialis-form-with-validation>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'MobileCodeSender',
  computed: {
    ...mapGetters({
      getBusinessName: 'business/getBusinessName',
      vehicleString: 'vehicle/vehicleString',
      financeApplicationIsComplete: 'lead/financeApplicationIsComplete',
      financeApplicationIsExpired: 'lead/financeApplicationIsExpired',
    }),
    ...mapState('lead', ['consumerBasicInfo']),
    formattedPhoneNumber() {
      const number = this.consumerBasicInfo.phoneNumber;
      const lineNumber = number.slice(6, 10);
      return `(***) ***-${lineNumber}`;
    },
  },
  async created() {
    await this.getConsumerBasicInfo();
  },
  methods: {
    async getConsumerBasicInfo() {
      try {
        this.$store.commit('SET_LOADING', true);
        await this.$store.dispatch('lead/getBasicInfo');
        if (this.financeApplicationIsComplete) {
          this.$router.push('application-previously-submitted');
        } else if (this.financeApplicationIsExpired) {
          this.$router.push('application-expired');
        }
      } catch (error) {
        this.$router.push('returning-customer-mobile-verification-error');
        this.$log('Error getting consumer basic info', error);
      } finally {
        this.$store.commit('SET_LOADING', false);
      }
    },
    async sendMobileOtp() {
      try {
        this.$store.commit('SET_LOADING', true);
        await this.$store.dispatch('lead/sendMobileOtp');
        this.$router.push('returning-customer-mobile-verification');
      } catch (error) {
        this.$router.push('returning-customer-mobile-verification-error');
        this.$log('Error in sending verification code in MobileCodeSender', error);
      } finally {
        this.$store.commit('SET_LOADING', false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/variables';
.mobile-verification-container {
  @media (min-width: 575px) {
    min-height: 65vh;
    position: relative;
  }
}
small {
  font-size: 14px;
}
.send-button {
  @media (min-width: 575px) {
    position: absolute;
    bottom: 0;
  }
}
</style>
